/**Get Pending Claims */
export const GET_CLAIMS = 'GET_CLAIMS';
export const GET_CLAIMS_SUCCESS = 'GET_CLAIMS_SUCCESS';

export const GET_PENDING_CLAIMS_TOTAL = 'GET_PENDING_CLAIMS_TOTAL';
export const GET_PENDING_CLAIMS_TOTAL_SUCCESS = 'GET_PENDING_CLAIMS_TOTAL_SUCCESS';

export const GET_BILLABLE_CLAIMS_TOTAL = 'GET_BILLABLE_CLAIMS_TOTAL';
export const GET_BILLABLE_CLAIMS_TOTAL_SUCCESS = 'GET_BILLABLE_CLAIMS_TOTAL_SUCCESS';

export const GET_CLAIM_AGING = 'GET_CLAIM_AGING';
export const GET_CLAIM_AGING_SUCCESS = 'GET_CLAIM_AGING_SUCCESS';
export const GET_COMPLETE_CLAIM_TOTALS = 'GET_COMPLETE_CLAIM_TOTALS';
export const GET_COMPLETE_CLAIM_TOTALS_SUCCESS = 'GET_COMPLETE_CLAIM_TOTALS_SUCCESS';
export const GET_SUBMITTED_CLAIMS = 'GET_SUBMITTED_CLAIMS';
export const GET_SUBMITTED_CLAIMS_SUCCESS = 'GET_SUBMITTED_CLAIMS_SUCCESS';

/**Submitted Claim Batches (Batch View) — GET /claim/batch */
export const GET_CLAIM_BATCHES = 'GET_CLAIM_BATCHES';
export const GET_CLAIM_BATCHES_SUCCESS = 'GET_CLAIM_BATCHES_SUCCESS';

/**Single batch with populated claims (accordion expand) — GET /claim/batch/:id */
export const GET_CLAIM_BATCH_BY_ID = 'GET_CLAIM_BATCH_BY_ID';
export const GET_CLAIM_BATCH_BY_ID_SUCCESS = 'GET_CLAIM_BATCH_BY_ID_SUCCESS';
export const APPEAL_SUBMITTED_CLAIM = 'APPEAL_SUBMITTED_CLAIM';

/**Get Claim by Id */
export const GET_CLAIM_BY_ID = 'GET_CLAIM_BY_ID';
export const GET_CLAIM_BY_ID_SUCCESS = 'GET_CLAIM_BY_ID_SUCCESS';

/**generate Claim */
export const GENERATE_CLAIM = 'GENERATE_CLAIM';
export const EDIT_CLAIM = 'EDIT_CLAIM';
export const DELETE_CLAIM = 'DELETE_CLAIM';
export const CHANGE_CLAIM_STATUS = 'CHANGE_CLAIM_STATUS';
/**Claim Status Actions */
export const CANCEL_CLAIM = 'CANCEL_CLAIM';
export const CLOSE_CLAIM = 'CLOSE_CLAIM';
export const SUBMIT_CLAIM = 'SUBMIT_CLAIM';
export const RE_SUBMIT_CLAIM = 'RE_SUBMIT_CLAIM';
export const SUBMIT_CLAIM_BY_ID = 'SUBMIT_CLAIM_BY_ID';
export const REFRESH_CLAIM = 'REFRESH_CLAIM';
export const REFRESH_CLAIM_SUCCESS = 'REFRESH_CLAIM_SUCCESS';
export const RESUBMIT_CLAIM = 'RESUBMIT_CLAIM';
export const REMOVE_APPT_FROM_CLAIM = 'REMOVE_APPT_FROM_CLAIM';
export const CHECK_CLAIM_STATUS = 'CHECK_CLAIM_STATUS';

/**Bill Details */
export const GET_BILL_CLAIM_PAYMENT_TRANSACTIONS = 'GET_BILL_CLAIM_PAYMENT_TRANSACTIONS';
export const GET_BILL_CLAIM_PAYMENT_TRANSACTIONS_SUCCESS = 'GET_BILL_CLAIM_PAYMENT_TRANSACTIONS_SUCCESS';

export const GET_BILL_INVOICE_PAYMENT = 'GET_BILL_INVOICE_PAYMENT';
export const GET_BILL_INVOICE_PAYMENT_SUCCESS = 'GET_BILL_INVOICE_PAYMENT_SUCCESS';

/** Overview */
export const GET_BILLING_OVERVIEW = 'GET_BILLING_OVERVIEW';
export const GET_BILLING_OVERVIEW_SUCCESS = 'GET_BILLING_OVERVIEW_SUCCESS';

export const REFRESH_APPT_UNITS = 'REFRESH_APPT_UNITS';

export const MARK_AS_SECONDARY_BILLING = 'MARK_AS_SECONDARY_BILLING';
export const MARK_AS_READY_SECONDARY_BILLING = 'MARK_AS_READY_SECONDARY_BILLING';
export const EDIT_READY_SECONDARY_BILLING = 'EDIT_READY_SECONDARY_BILLING';

/** Bill Adjustments (CAS) */
export const UPDATE_BILL_ADJUSTMENTS = 'UPDATE_BILL_ADJUSTMENTS';
